import Joi from "joi";
import { AppType } from "../../enum/app";
import { BidTypes, MinBid, Products } from "../../enum/campaign";
import { minTotalBudget } from "./constants";

export const campaignSettingsSchema = Joi.object({
  name: Joi.string().trim().required().messages({
    "any.required": "Company name is required",
  }),
  product: Joi.string().trim().required().messages({
    "any.required": "Product is required",
  }),
  bidType: Joi.string().trim().required().messages({
    "any.required": "Bid type is required",
  }),
  webUrl: Joi.string()
    .trim()
    .uri()
    .allow("")
    .when("product", { is: Products.Website, then: Joi.required() })
    .messages({
      "any.required": "Website url is required",
    }),
  app: Joi.object({
    id: Joi.string().trim(),
    name: Joi.string().trim(),
    url: Joi.string().uri().trim(),
    type: Joi.string().valid(...[AppType.Android, AppType.IOS]),
  })
    .when("product", { is: Products.App, then: Joi.object().min(4) })
    .messages({
      "object.min": "Please select app",
    }),
  startDate: Joi.string().trim().required().messages({
    "any.required": "Start date is required",
  }),
  endDate: Joi.string().trim().required().messages({
    "any.required": "End date is required",
  }),
  type: Joi.string().trim().required().messages({
    "any.required": "required",
  }),
  country: Joi.string().trim().required().messages({
    "any.required": "Country is required",
  }),
  interests: Joi.array()
    .items(
      Joi.object({
        id: Joi.string().trim().required(),
        name: Joi.string().trim().required(),
      }),
    )
    .messages({
      "any.required": "Inerest is required",
      "array.min": "Inerest is required",
    }),
  languages: Joi.array()
    .items(
      Joi.object({
        id: Joi.string().trim().required(),
        name: Joi.string().trim().required(),
      }),
    )
    .messages({
      "any.required": "Language is required",
      "array.min": "Language is required",
    }),
  ageGroups: Joi.array()
    .items(
      Joi.object({
        id: Joi.string().trim().required(),
        name: Joi.string().trim().required(),
      }),
    )
    .messages({
      "any.required": "Age Group is required",
      "array.min": "Age Group is required",
    }),
  totalBudget: Joi.number()
    .positive()
    .min(minTotalBudget)
    .required()
    .messages({
      "any.required": "Total budget is required",
      "number.min": `Minimum total budget must be $${minTotalBudget}`,
    }),
  dailyBudget: Joi.number()
    .positive()
    .min(minTotalBudget)
    .max(Joi.ref("totalBudget"))
    .required()
    .messages({
      "any.required": "Daily budget is required",
      "number.min": `Minimum Daily budget must be $${minTotalBudget}`,
      "number.max": "Daily budget must be less then total budget amount.",
    }),
  bidAmount: Joi.number()
    .positive()
    .required()
    .when("bidType", { is: BidTypes.CPC, then: Joi.number().min(MinBid.CPC) })
    .concat(
      Joi.number()
        .positive()
        .required()
        .when("bidType", {
          is: BidTypes.CPI,
          then: Joi.number().min(MinBid.CPI),
        }),
    )
    .concat(
      Joi.number()
        .positive()
        .required()
        .when("bidType", {
          is: BidTypes.CPL,
          then: Joi.number().min(MinBid.CPL),
        }),
    )
    .messages({
      "any.required": "Bid amount is required",
      "number.min": `Minimum bid amount must be as per Bid Type. CPC - $${MinBid.CPC}, CPI - $${MinBid.CPI}, CPL - $${MinBid.CPL}`,
    }),
});

export const campaignTrackingSchema = Joi.object({
  partner: Joi.string().trim().required().messages({
    "any.required": "Tracking vendor is required",
  }),
  impressionUrl: Joi.string().uri().trim().required().messages({
    "any.required": "Tracking url is required",
    "any.empty": "Tracking url is required",
    "string.uri": "Tracking url must be a valid url",
  }),
});

export const campaignAdCreativesSchema = Joi.object({
  bannerImage: Joi.array().min(1).messages({
    "array.min": "Banner image is required",
  }),
});
